import React, { createContext, useContext, useState } from "react";
import { getUserLanguage } from "utils/local-storage";

// Create a context for translation-related data
const TranslationContext = createContext();

/**
 * TranslationProvider component to manage language selection and translations
 * across the application.
 */
export const TranslationProvider = ({ children }) => {
  // State to store the current locale (default is English)
const [locale, setLocale] = useState(getUserLanguage() || "ch");

  // Dynamically import the translation file based on the selected locale
  const translate = require(`./../public/locales/${locale || "ch"
    }/default.json`);

  return (
    <TranslationContext.Provider value={{ locale, setLocale, translate }}>
      {children}
    </TranslationContext.Provider>
  );
};

/**
 * Custom hook to access the translation context.
 * This allows components to easily get and update translation data.
 */
export const useTranslation = () => useContext(TranslationContext);
